import { EXCEPTIONS_AND_OPPORTUNITY } from "./exceptionsAndOpportunity";
import { SCHEDULED_COLLECTIONS } from "./scheduledCollections";
import { STOP_TYPE } from "./stopType";
import { STOP_VOLUMES } from "./stopVolumes";
import { DRIVER_TYPE } from "./driverType";
import { VEHICLE_TYPE } from "./vehicleType";
import { PLANNED_READY_TIME } from "./plannedReadyTime";
import { SECTION } from "./section";
import { ROBOT_SUPPLIER } from "./robotSupplier";
import { PICKUP_TYPE } from "./pickupTypes";

export const planManagementFilters = [
  EXCEPTIONS_AND_OPPORTUNITY,
  STOP_TYPE,
  SCHEDULED_COLLECTIONS,
  VEHICLE_TYPE,
  STOP_VOLUMES,
  PLANNED_READY_TIME,
  SECTION,
  ROBOT_SUPPLIER,
  PICKUP_TYPE,
];
export const driverManagementFilters = [DRIVER_TYPE, VEHICLE_TYPE];
